<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Wallet Logs",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Wallet Logs",
            items: [
               {
                  text: "Users",
                  href: "/patients",
               },  
               
               {
                  text: "Wallet Logs",
                  active: true,
               },                   
            ],

            logs: [],  
            user: {},

            pagination: {},
            from: null,
            to: null,
            total: null,
            type: "",
            
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            points: "",
            points2: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
         
      },

      created() {
         this.fetchLogs();
      },

      methods: {
         fetchLogs(page_url = null) {

            this.getToken();
            let url = "api/admin/patient/walletLogs?limit=" + this.listing_length+ "&patient_id="  + this.$route.params.id;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;

            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.logs = responseData.wallet_logs.data;
                  this.user = responseData.patient;

                  this.pagination = responseData.wallet_logs.links;
                  this.from = responseData.wallet_logs.from;
                  this.to = responseData.wallet_logs.to;
                  this.total = responseData.wallet_logs.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 
         addPoints(){
            this.getToken();
            const config = {
               headers: {

                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

         let url = "api/admin/patient/wallet/add";
         let formData = new FormData();
         formData.append("patient_id", this.$route.params.id);
         formData.append("points", this.points);

         this.$axios
            .post(url, formData, config)
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.clearForm();
               this.hideModal('points-modal');
               this.fetchLogs(this.active_page_url);

            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     this.$swal("", error.response.data.message, "error");
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
         },

         removePoints(){
            this.getToken();
            const config = {
               headers: {

                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

         let url = "api/admin/patient/wallet/remove";
         let formData = new FormData();
         formData.append("patient_id", this.$route.params.id);
         formData.append("points", this.points2);

         this.$axios
            .post(url, formData, config)
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.clearForm();
               this.hideModal('points-modal2');
               this.fetchLogs(this.active_page_url);

            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                     this.$swal("", error.response.data.message, "error");

                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
         },
         clearForm() {
            this.points = "";
            this.errors = {};
            this.points2 = "";
         },
         getToken() {
         if (localStorage.getItem('medicino_admin')) {
            var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
            if(medicino_admin.token) {
               this.token = medicino_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
            
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
         }, 
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },    
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <!-- <router-link :to="{ name: 'patients' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link> -->
                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <div class="row">
                     <div class="col-md-4">
                        <b-media class="mb-4">
                              <b-media-body class="ms-3">
                                 <h5 class="mt-1 mb-1">{{user.patient_name}}</h5>
                                 <p>
                                    {{user.country_code}} {{user.mobile}}<br>
                                    {{user.email}}
                                 </p>
                              </b-media-body>
                        </b-media>
                     </div>
                     <div class="col-md-6">
                              <div class="media">
                                 <div class="avatar-sm align-self-center me-4 rounded-circle bg-primary">
                                    <span class="avatar-title">
                                          <i class="fas fa-certificate font-size-24"></i>
                                    </span>
                                 </div>
                                 <div class="media-body">
                                    <p class="text-muted fw-medium mb-2">Wallet Balance(Coins)</p>
                                    <h4 class="mb-0" v-if="user.coins">{{ user.coins }}</h4>
                                    <h4 class="mb-0" v-else>0</h4>
                                 </div>                              
                              </div>
                     </div>
                  </div>


                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchLogs()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        
                        <b-button v-if="Boolean(logs.length)" v-b-modal.points-modal2 variant="primary" class="float-end me-2">Remove Coins</b-button>
                        <b-button  v-b-modal.points-modal variant="primary" class="float-end me-2">Add Coins</b-button>

                     </div> 
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>SI No.</th>
                              <th>Credit(Coins) </th>
                              <th>Debit(Coins)</th>
                              <th>Current Balance(Coins)</th>
                              <th>Booking ID</th>
                              <th>Created On</th>
                              <th>Method</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(logs.length)">
                           <tr v-for="(log, index) in logs" :key="log.id">
                              <td>{{index + from}}</td>
                              <td><span v-if="log.type==1">{{log.coins}}</span></td>
                              <td><span v-if="log.type==2">{{log.coins}}</span></td>
                              <td>{{log.balance_coins}}</td>
                              <td><span v-if="log.booking_id">#{{log.booking_id}}</span>
                                 </td>                              
                              <td>{{log.created_at | formatDateTime}}</td>
                              <td>
                                 <span v-if="log.transaction_type == 1">By Booking</span>
                                 <span v-else>By Admin</span>
                              </td>  
                              <td>
                                 <span v-if="log.booking_id">
                                 <router-link :to="{ name: 'consultations.details', params: {id: log.booking_id}}" class="btn btn-primary me-2 mb-2 btn-sm">Booking Details</router-link>
                              </span>
                              </td>
                           </tr>   
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="7" class="text-center">No logs found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(logs.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchLogs(page.url + '&limit='+ listing_length + '&patient_id='  + $route.params.id)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

                  <!---- modal starts ---->
                  <b-modal ref="points-modal" id="points-modal" title="Add Coins" hide-footer>
                     <b-form @submit.prevent="addPoints()">                        
                        <div class="row">                            

                           <b-form-group class="col-lg-12">
                              <label>Coins <span class="text-danger">*</span></label>
                              <b-form-input v-model="points" @keypress="numbersOnly" v-bind:class="{ 'is-invalid': Boolean(errors.points) }"></b-form-input>
                              <div v-for="(val, index) in errors.points" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <!-- <b-form-group class="col-lg-12">
                                 <label>Amount </label>
                                 <input type="email" v-model="amount" class="form-control" disabled />

                               
                              </b-form-group> -->

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                              <b-button class="" variant="light" @click="hideModal('points-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->   

                   <!---- modal starts ---->
                   <b-modal ref="points-modal2" id="points-modal2" title="Remove Coins" hide-footer>
                     <b-form @submit.prevent="removePoints()">                        
                        <div class="row">                            

                           <b-form-group class="col-lg-12">
                              <label>Coins <span class="text-danger">*</span></label>
                              <b-form-input v-model="points2" @keypress="numbersOnly" v-bind:class="{ 'is-invalid': Boolean(errors.points) }"></b-form-input>
                              <div v-for="(val, index) in errors.points" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <!-- <b-form-group class="col-lg-12">
                                 <label>Amount </label>
                                 <input type="email" v-model="amount" class="form-control" disabled />

                               
                              </b-form-group> -->

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                              <b-button class="" variant="light" @click="hideModal('points-modal2')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->  

               </div>
            </div>
         </div>
      </div>

   </Layout>
</template>
